/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NarrativeRootAdminResponse } from '../models/NarrativeRootAdminResponse';
import type { PillarNarrativePlanningConfigResponse } from '../models/PillarNarrativePlanningConfigResponse';
import type { ScopeType } from '../models/ScopeType';
import type { SidebarCountsResponse } from '../models/SidebarCountsResponse';
import type { WorkstreamNavTreeResponse } from '../models/WorkstreamNavTreeResponse';
import type { WorkstreamNearestTeamResponse } from '../models/WorkstreamNearestTeamResponse';
import type { WorkstreamPillarLevelConfigAdminResponse } from '../models/WorkstreamPillarLevelConfigAdminResponse';
import type { WorkstreamPillarLevelConfigAdminUpdate } from '../models/WorkstreamPillarLevelConfigAdminUpdate';
import type { WorkstreamsResponse } from '../models/WorkstreamsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkstreamListService {

    /**
     * Get Workstreams
     * Fetch workstreams with scope-based filtering, sorting, and grouping.
     * @param scopeType
     * @param scopeValue
     * @param filters
     * @param sortColumn
     * @param sortDirection
     * @param groupBy
     * @param activeGroup
     * @param narrativeOnly
     * @param limit
     * @param cursor
     * @returns WorkstreamsResponse Successful Response
     * @throws ApiError
     */
    public static getWorkstreamsApiV1WorkstreamWorkstreamsGet(
        scopeType: ScopeType,
        scopeValue?: (string | null),
        filters?: (string | null),
        sortColumn?: (string | null),
        sortDirection?: (string | null),
        groupBy?: (string | null),
        activeGroup?: (string | null),
        narrativeOnly: boolean = false,
        limit: number = 50,
        cursor?: (number | null),
    ): CancelablePromise<WorkstreamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/workstreams',
            query: {
                'scope_type': scopeType,
                'scope_value': scopeValue,
                'filters': filters,
                'sort_column': sortColumn,
                'sort_direction': sortDirection,
                'group_by': groupBy,
                'active_group': activeGroup,
                'narrative_only': narrativeOnly,
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Prototype Nav Tree
     * PROTOTYPE-ONLY: lightweight left-rail nav tree for the /workstreams-v3 UI.
     *
     * Returns just the outline (id, name, pillar, parent edges, health chip) for the
     * active scope + its accessible ancestor closure, so the tree loads fast and
     * independently of the heavy detail/table payload. Only ``filters.timeframes`` is
     * honored here; all other filtering happens on the right-pane list query. This
     * endpoint is additive and not used by any existing (non-prototype) surface.
     * @param scopeType
     * @param scopeValue
     * @param filters
     * @returns WorkstreamNavTreeResponse Successful Response
     * @throws ApiError
     */
    public static getPrototypeNavTreeApiV1WorkstreamPrototypeNavTreeGet(
        scopeType: ScopeType,
        scopeValue?: (string | null),
        filters?: (string | null),
    ): CancelablePromise<WorkstreamNavTreeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/prototype/nav-tree',
            query: {
                'scope_type': scopeType,
                'scope_value': scopeValue,
                'filters': filters,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Prototype Nearest Team
     * PROTOTYPE-ONLY: what an empty My workstreams shows instead — the viewer's
     * closest team (their own, then up toward their org) with workstreams in
     * ``filters.timeframes``, counting sub-teams' workstreams, and those ids.
     * Only ``filters.timeframes`` is honored.
     * @param filters
     * @returns WorkstreamNearestTeamResponse Successful Response
     * @throws ApiError
     */
    public static getPrototypeNearestTeamApiV1WorkstreamPrototypeNearestTeamGet(
        filters?: (string | null),
    ): CancelablePromise<WorkstreamNearestTeamResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/prototype/nearest-team',
            query: {
                'filters': filters,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Admin Narrative Root
     * Resolve the narrative root workstream id for pillar admin.
     * @param timeframe Planning period label (e.g. H1 FY26, H2 FY26). Defaults like pillar-configs.
     * @returns NarrativeRootAdminResponse Successful Response
     * @throws ApiError
     */
    public static getAdminNarrativeRootApiV1AdminWorkstreamNarrativeRootGet(
        timeframe?: (string | null),
    ): CancelablePromise<NarrativeRootAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/workstream/narrative-root',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Admin Pillar Level Configs
     * List editable level behavior for every active direct narrative pillar.
     * @param timeframe Planning period label (e.g. H1 FY26, H2 FY26).
     * @returns WorkstreamPillarLevelConfigAdminResponse Successful Response
     * @throws ApiError
     */
    public static listAdminPillarLevelConfigsApiV1AdminWorkstreamPillarLevelConfigsGet(
        timeframe?: (string | null),
    ): CancelablePromise<Array<WorkstreamPillarLevelConfigAdminResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/workstream/pillar-level-configs',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Admin Pillar Level Config
     * Update one direct narrative pillar's level behavior.
     * @param pillarWorkstreamId
     * @param requestBody
     * @param timeframe Planning period label (e.g. H1 FY26, H2 FY26).
     * @returns WorkstreamPillarLevelConfigAdminResponse Successful Response
     * @throws ApiError
     */
    public static updateAdminPillarLevelConfigApiV1AdminWorkstreamPillarLevelConfigsPillarWorkstreamIdPut(
        pillarWorkstreamId: number,
        requestBody: WorkstreamPillarLevelConfigAdminUpdate,
        timeframe?: (string | null),
    ): CancelablePromise<WorkstreamPillarLevelConfigAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/workstream/pillar-level-configs/{pillar_workstream_id}',
            path: {
                'pillar_workstream_id': pillarWorkstreamId,
            },
            query: {
                'timeframe': timeframe,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Pillar Configs
     * Return persisted pillar narrative links for the requested period.
     * @param timeframe Planning period (e.g. H1 FY26, H2 FY26). Must match narrative timeframe strings. Defaults to the active default when omitted.
     * @returns PillarNarrativePlanningConfigResponse Successful Response
     * @throws ApiError
     */
    public static getPillarConfigsApiV1WorkstreamPillarConfigsGet(
        timeframe?: (string | null),
    ): CancelablePromise<Record<string, PillarNarrativePlanningConfigResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/pillar-configs',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Pillars
     * Get distinct pillar names derived from the narrative hierarchy.
     * @param timeframe
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getPillarsApiV1WorkstreamPillarsGet(
        timeframe?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/pillars',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Sidebar Counts
     * Get counts for the sidebar navigation.
     * @param timeframe
     * @returns SidebarCountsResponse Successful Response
     * @throws ApiError
     */
    public static getSidebarCountsApiV1WorkstreamSidebarCountsGet(
        timeframe?: (string | null),
    ): CancelablePromise<SidebarCountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/sidebar-counts',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
